export const isHeaderFooterEnabled = process.env.GATSBY_HEADER_FOOTER
  ? Boolean(process.env.GATSBY_HEADER_FOOTER === 'true')
  : true;
